<div *ngIf="!connected">
  Todavía no has configurado la conexión con Office365.<br /><br />
  Para poder configurar las opciones de integración primero debes conectar tu cuenta de Office 365.<br /><br />
  Por favor, pulsa el boton <b>"Conectar ahora"</b> para comenzar.
</div>

<p-card *ngIf="connected">
  <ng-template pTemplate="header">
    <div class="p-card-title">
      Información de conexión
    </div>
  </ng-template>

  <div class="p-grid">
    <div class="p-col-8 p-field p-m-0">
      <label>Conectado con</label>
      <label>{{connectionInfo?.userPrincipalName}}</label>
    </div>
    <div class="p-col-4 p-field p-m-0">
      <label>Id</label>
      <label>{{connectionInfo?.id}}</label>
    </div>
  </div>
</p-card>

<div *ngIf="connected">
  <p-card styleClass="p-mt-4" *ngFor="let o365User of integration.configuration.users">
    <div class="user-config p-d-flex">
      <img src="/assets/img/no-user.jpeg">
      <div class="flex-grow-1 p-d-flex p-flex-column">
        <b>{{o365User.displayName}}</b>
        <small>{{o365User.userPrincipalName}}</small>
        <div class="p-d-flex p-ai-center">
          <fa-icon [icon]="['fas','address-card']" class="p-mr-2 {{(o365User.contacts.enabled?'user-config-option-enabled':'user-config-option-disabled')}}"></fa-icon>
          <fa-icon [icon]="['fas','envelope']" class="p-mr-2 {{(o365User.mail.enabled?'user-config-option-enabled':'user-config-option-disabled')}}"></fa-icon>
          <fa-icon [icon]="['fas','calendar']" class="{{(o365User.calendar.enabled?'user-config-option-enabled':'user-config-option-disabled')}}"></fa-icon>
        </div>
      </div>
      <div class="p-d-flex p-flex-column p-ai-center p-jc-center">
        <a (click)="configUser(o365User)">
          <fa-icon [icon]="['fas', 'cog']"></fa-icon>
        </a>
      </div>
    </div>
  </p-card>
  <div *ngIf="!integration.configuration.users">
    <p-messages severity="error" class="p-d-block">
      <ng-template pTemplate>
        No hemos podido recuperar los usuarios de tu cuenta de Office.<br />
        Por favor, intente de nuevo la operación pasados unos minutos.<br />
        Si el problema persiste, contacte con el servicio de soporte.
      </ng-template>
    </p-messages>
  </div>
</div>

<div class="p-col-12 p-d-flex p-mt-4">
  <button pButton label="Desconectar" icon="pi pi-times" class="p-button-danger p-button-text" (click)="disconnect()" *ngIf="connected"></button>
  <div class="flex-grow-1"></div>
  <button pButton label="Reconectar" icon="pi pi-refresh" class="p-button-secondary p-button-text" (click)="connect()" *ngIf="connected"></button>
  <!--<button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary p-button-text" (click)="cancel()"></button>-->
  <button class="p-ml-2" style="float: right;" icon="pi pi-save" pButton type="button" label="Guardar" (click)="save()" *ngIf="connected"></button>
  <button class="p-ml-2" style="float: right;" icon="pi pi-link" pButton type="button" label="Conectar ahora" (click)="connect()" *ngIf="!connected"></button>
</div>
